export const zh = {
  "AppName": "PG&E 理賠",
  "Calendar": "行事曆",
  "ShowTimePicker": "顯示時間選擇器",
  "Questionnaire": "問卷",
  "ClaimantHeading": "理賠申請人資訊",
  "IncidentInformationHeading": "事故資訊",
  "ClaimDetailsHeading": "理賠詳情",
  "Witnesses": "目擊者",
  "Supporting_documents": "證明文件",
  "Confirmation": "確認",
  "Stepper_1": "1. 問卷",
  "Stepper_2": "2. 理賠申請人資訊",
  "Stepper_3": "3. 事故資訊",
  "Stepper_4": "4. 理賠詳情",
  "Stepper_5": "5. 目擊者",
  "Stepper_6": "6. 證明文件",
  "Stepper_7": "7. 確認",
  "QuestionnaireDesc": "我們了解您遭受了損失，且您認為 PG&E 可能需負起責任。為了評估您的理賠申請，請提供以下資訊。",
  "InitialQuestion1":"您的理賠申請是否與暴風雨、停電或公共安全斷電 (PSPS) 事件有關？",
  "Yes": "是",
  "No": "否",
  "QuestionnaireDescYes": "如果您是住宅顧客，並因惡劣的暴風雨肆虐而連續停電 48 小時以上，您則符合安全網計劃的自動付款資格。此計劃提供 25 美元到 100 美元的款項，會在暴風雨停電後約 60 天自動付款。",
  "QuestionnaireMoreInfo": "如需更多關於安全網 (Safety Net) 付款的資訊，請",
  "QuestionnaireMoreInfoLink": "瀏覽停電補償",
  "QuestionnaireAutomaticProgram": "這是根據資格自動執行的計劃，您無需採取進一步行動。",
  "FullStop": "。",
  "InitialQuestion": "您是否仍要提出理賠申請（是/否）",
  "InitialQuestion3Info": "一般而言，PG&E 對於並非由我們造成或因不可抗力因素所導致的損害不負責任。例如，在大多數情況下，我們不對以下情況負責：因閃電、洪水、暴風雨等天氣相關狀況、植被（樹木/樹枝）、酷熱或強風、地震或其他自然災害造成的停電、電壓波動或財產損害。",
  "Error": "錯誤：請選擇一個答案",
  "Next": "下一步",
  "Helpline": "您在線上提交理賠申請時如遇到困難，請撥打 PG&E 理賠協助專線",
  "ForAssistance.": "尋求協助。",
  "Information": "資訊",
  "RequiredField": "*必填欄位",
  "AccountNumber": "PG&E 帳號",
  "AccountNumberTooltip": "您的帳號位於每月 PG&E 能源帳單的右上方。",
  "AccountNumberOptional": "此栏为选填项.",
  "accountnumber": "帳號",
  "InvalidAcNmbr": "無效的帳號",
  "BusinessName": "企業名稱",
  "FirstName":"名字",
  "LastName":"姓氏",
  "MailingAddress":"通訊地址",
  "AptSuite":"公寓/套房",
  "City":"城市",
  "ZIPCode":"郵遞區號",
  "State":"州",
  "PhoneNumber": "電話號碼",
  "PrimaryPhone":"主要電話號碼",
  "AlternatePhone":"備用電話號碼",
  "Email":"電子郵件地址",
  "ConfirmEmail":"確認電子郵件地址",
  "AreYouPG&EEmployee":"您是否為 PG&E 員工？",
  "PGEEmployee": "PG&E 員",
  "LANID":"LAN ID",
  "Back": "返回",
  "ErrorAccountNumberDigits": "錯誤：請輸入至少 10 位數",
  "ErrorFirstNameRequired": "錯誤：必須填寫名字",
  "ErrorLastNameRequired": "錯誤：必須填寫姓氏",
  "ErrorMailingAddressRequired": "錯誤：必須填寫通訊地址",
  "ErrorCityRequired": "錯誤：必須填寫城市",
  "ErrorZipCodeRequired": "錯誤：輸入郵遞區號",
  "ErrorPhneNumbrRequired": "錯誤：請輸入有效的電話號碼",
  "ErrorPhoneNumber10Digits": "錯誤：您必須輸入 10 位數的電話號碼",
  "ErrorValidEmail": "錯誤：請輸入有效的電子郵件地址",
  "ErrorEmailsMustMatch": "錯誤：電子郵件地址必須相符",
  "ErrorPGEEmployeeRequired": "錯誤：您目前是否受僱於 PG&E？ 若否，請在上方選擇「否」",
  "ErrorLANIDRequired": "錯誤：必須填寫 LAN ID",
  "ErrorLANIDValid": "錯誤：請輸入有效的 LAN ID",
  "EstimatedDateOfIncident": "估計事故發生日期",
  "IncDate": "月/日/年",
  "EstimatedTimeOfIncident": "估計事故發生時間（若已知）",
  "Today": "今天",
  "SameAsMailingAddress": "是否與通訊地址相同？",
  "Location": "*地點",
  "StreetAddress": "街道地址",
  "OtherDescribe": "其他/描述",
  "IncidentAddress": "事故地址",
  "DescriptionOfLocation": "地點描述",
  "YouHave": "您還有",
  "CharactersRemaining": "個字元",
  "ErrorPleaseEnterValidDate": "錯誤：請輸入有效的日期",
  "ErrorValidDateFormat": "錯誤：請按月/日/年格式輸入有效的日期",
  "ErrorFutureDateNotAllowed": "錯誤：不允許使用未來的日期",
  "ErrorYearCurrentCentury": "錯誤：年份必須在本世紀", 
  "ErrorValidTime12Hour": "錯誤：請以 12 小時制輸入有效時間",
  "ErrorOneSelectionRequired": "錯誤：必須選擇一個項目",  
  "ErrorIncidentAddressRequired": "錯誤：必須填寫事故地址",  
  "ErrorLocationDescriptionRequired": "錯誤：必須填寫地點描述",  
  "DescribeWhatHappened": "請描述發生的經過",  
  "Subtotal": "小計",
  "IsThisClaimForBusiness": "此理賠是否與您的企業有關？",
  "EstimatedRevenueLoss": "估計營收損失",  
  "WagesPaidToHourlyEmployees": "支付給時薪員工的工資",
  "LostInventory": "庫存損失",
  "WereYouInjured": "您是否受傷？",
  "IncidentInvolves": "事故涉及項目",
  "BodilyInjury": "人身傷害",
  "PropertyDamageFoodSpoilageLabel": "財產損害/食物腐壞",
  "PropertyDamageOrFoodSpoilage": "财产损坏或食物变质",
  "Both": "兩者皆有",
  "IsThisMotorVehicleIncident": "這是否為機動車輛事故？",
  "VehicleInfo": "車輛資訊",
  "CarMake": "車輛廠牌",
  "CarModel": "車輛型號",
  "CarYear": "車輛年份",
  "EstimatedDamages": "估計損害",
  "LicensePlateNumber": "車牌號碼",
  "StateRegistered": "註冊州別",
  "IsClaimantOwnerOfVehicle": "理賠申請人是否為車主？",
  "VehicleOwnerInformation": "車主資訊",
  "VehicleOwnerFirstName": "車主的名字",
  "VehicleOwnerLastName": "車主的姓氏",
  "Address": "地址",
  "Select": "選取",
  "LostWages": "薪資損失（如有）",
  "MedicalExpenses": "醫療費用（如有）",
  "OtherLosses": "其他損失",
  "PleaseDescribeOtherLosses": "請描述其他損失",
  "TotalAmountClaimed": "理賠申請總額",
  "DamagedItems": "受損項目（不含車輛)",
  "AddItem": "新增項目",
  "DeleteItem": "刪除",
  "DeleteItemConfirmation": "您要刪除此內容嗎？",
  "Delete": "刪除內容",
  "NoteMoreThan10Items": "注意：如果您有超過 10 件商品，請在步驟 4 中將商品清單作為附件上傳。",
  "UpdateItem": "更新內容",
  "MakeBrand": "廠牌/品牌",
  "Model": "型號",
  "Year": "年份",
  "Amount": "*金額",
  "ItemDescription": "*項目描述",
  "Makebrand": "廠牌/品牌",
  "Itemdescription": "*項目描述",
  "Submit": "提交",
  "Cancel": "取消",
  "ErrorDetailedDescriptionRequired": "錯誤：需要詳細描述",
  "ErrorBusinessNameRequired": "錯誤：必須填寫企業名稱", 
  "ErrorCarMakeRequired": "錯誤：必須填寫車輛廠牌",
  "ErrorCarModelRequired": "錯誤：必須填寫車輛型號",
  "ErrorCarYearRequired": "錯誤：必須填寫車輛年份",
  "ErrorEstimatedDamagesRequired": "錯誤：必須填寫估計損害。",
  "ErrorLicensePlateNumberRequired": "錯誤：必須填寫車牌號碼。",
  "ErrorItemDescriptionRequired": "錯誤：必須填寫項目描述",
  "ErrorAmountRequired": "錯誤：必須填寫金額",
  "ErrorInvalidAmountEntry": "錯誤：輸入的金額無效。請輸入介於 0.00 至 10000000.00 之間的數值",
  "ErrorPleaseChooseOptionIncidentInvolves": "錯誤：請針對事故涉及項目選擇一個選項",
  "ErrorVehicleOwnerFirstNameRequired": "錯誤：必須填寫車主的名字",
  "ErrorVehicleOwnerLastNameRequired": "錯誤：必須填寫車主的姓氏",
  "ErrorVehicleOwnerAddressRequired": "錯誤：必須填寫車主地址",
  "ErrorVehicleOwnerCityRequired": "錯誤：必須填寫車主的城市",
  "ErrorVehicleOwnerStateRequired": "錯誤：必須填寫車主的州",
  "ErrorValidZipCode": "錯誤：請輸入有效的郵遞區號",
  "ErrorValidZipCodeNumber": "錯誤：請輸入有效的郵遞區號（例如：12345, 94538）",
  "ErrorVehicleOwnerPhoneRequired": "錯誤：必須填寫車主電話",
  "ErrorClaimantOwnerOfVehicle": "錯誤：請針對「理賠申請人是否為車主？」選擇一個選項",
  "ErrorMotorVehicleIncident": "錯誤：選擇一個選項。這是否為機動車輛事故?",
  "ErrorClaimForBusiness": "錯誤：選擇一個選項。此理賠是否與您的企業有關?",
  "WitnessesHeading": "目擊者（選填）",
  "WitnessesDescription": "如果沒有目擊者，可以跳過此步驟。這通常適用於涉及人身傷害的理賠。您最多可新增三位目擊者。",
  "Phone": "電話",
  "ZIP": "郵遞區號",
  'Firstname': "名字",
  'Lastname': "姓氏",
  "PGnEEmployee": "PGE 員工",
  "ResultsWillAppearInTable": "結果會顯示在下方表格。",
  "AddWitness": "新增目擊者",
  "ErrorMaxThreeWitnesses": "錯誤：您最多只能新增三位證人。",
  "UpdateWitness": "更新證人",
  "DeleteWitness": "刪除證人",
  "DeleteWitnessConfirmation": "您是否要刪除該證人？",
  "ErrorPleaseEnter" :"錯誤：請輸入",
  "ValidZip": "有效的郵遞區號" ,
  "ZipCodeExample": "(例如：12345, 94538)",
  "SupportingDocumentsHeading": "新增證明文件",
  "ProcessClaimsDescription": "為了處理您的理賠申請，我們需要每個理賠申請項目的證明文件。",
  "AddUpTo10Documents": "最多可新增 10 份文件（例如：收據和估價單）",
  "FilesLessThan10MB": "每個檔案必須小於 10MB",
  "FileTypesAccepted": "接受的檔案類型：.pdf、.txt、.doc、.docx、.xls、.xlsx、.jpg、.png、.heic 或 .jpeg。",
  "NOTE": "備註:",
  "NoteClaimsRepresentative": "您的理賠專員會在接下來 3 個工作天內與您聯絡。如果您有超過 10 份文件或有額外資訊，專員可以提供協助。",
  "AttachFile": "附加檔案",
  "AttachFileInstruction1": "按一下上傳圖示 [",
  "AttachFileInstruction1End": "]，並在您的桌上型電腦選取檔案。",
  "AttachFileInstruction2": "按一下「上傳」按鈕。",
  "AttachFileInstruction3": "檔案會以清單形式顯示在下方。",
  "MaxFileSize": "最大檔案大小：10MB",
  "Upload": "上傳",
  "Agreement": "協議",
  "FileNotUploaded": "檔案未上傳",
  "ErrorUploadDocument": "錯誤：處理您上傳的文件時發生問題。請重新上傳文件。",
  "FileNotUploadedMessage": "您尚未上傳所選取檔案，請按一下 [上傳 ^] 按鈕",
  "AgreementTerms": "*當我提交此表格，即表示我瞭解太平洋煤電公司會審查理賠申請的所有佐證文件。我證明前述輸入的資訊均屬真實正確。",
  "Security": "安全",
  "VerifyNotRobot": "請驗證您不是機器人。",
  "ErrorReadAgreeTerms": "錯誤：請閱讀並同意條款。",
  "ErrorVerifyNotRobot": "錯誤：驗證您不是機器人",
   "SubmitWithoutAttachment": "提交（無附加檔案）",
  "SubmitWithoutUploadingDocuments": "您是否要在不上傳文件的情況下提交此理賠申請？",
  "SubmitAnyway": "依然提交",
  "DontSubmit": "不要提交",
  "ErrorSubmitForm": "錯誤：處理您提交的表單時發生問題。請重新提交表單。",
  "ErrorFileSizeLessThan10MB": "錯誤：檔案大小必須小於 10MB",
  "ErrorProcessingRequest": "錯誤：處理您的請求時出現問題。請確認您已輸入所有必需資訊並重新提交。",
  "ErrorAllowedFileTypes": "錯誤：允許的文件類型 .pdf,.txt,.doc,.docx,.xls,.xlsx,.jpg,.png,.heic,.jpeg",
  "FilesAttached": "文件已附上",
  "Ok": "好的",
  "Recaptcha": "recaptcha",
  "ConfirmationHeading": "我們已收到您提交的理賠申請。",
  "YourClaimNumberIs": "您的理賠編號為",
  "ConfirmationDescription": "太平洋煤電公司的政策是迅速公平地回應客戶的理賠申請。所有理賠申請均依個案情況進行評估。我們的目標是在收到申請後的 30 天內解決您的理賠。不過部分理賠案件確實需要較長時間進行調查與解決。立即提交損失證明文件，可加快您的理賠處理速度。我們完成調查後，會透過電話聯絡您或寄發信函給您，說明我們的調查結果以及決定依據。",
  "WhatToExpect": "預期步驟",
  "ConfirmationDocument": "您如果尚未提供證明文件，或要提交額外文件（例如：收據或理賠申請項目的估價單），請將您的證明文件提交至：",
  "ConfirmationDocumentEmail": "claimsdocs@pge.com?subject=",
  "HelpDesk": "如有任何疑問，您可以撥打 415-973-4548 聯絡我們的服務台。",
  "Sincerely": "謹啟，",
  "PGEClaimsTeam": "PG&E 理賠團隊",  
  "Age": "年齡",
  "Action": "行動",
  "Edit": "編輯",
  "Add": "新增",
  "ErrorFileAlreadyUploaded": "錯誤：已上傳同名文件",
  "InfoBannerText": "您在線上提交理賠申請時如遇到困難，請撥打 PG&E 理賠協助專線 (415) 973-4548 尋求協助。",
  "SessionExpire15": "您的會話將在15分鐘後過期。",
  "SessionExpire5": "您的會話將在5分鐘後過期。",
  "SessionExpireWarning": "出於安全考慮，您的資料將在會話過期時刪除。",
  "StayConnected": "保持聯繫",
  "EndSession": "結束會話",
  "SessionExpired": "由於長時間未操作，您的會話已過期。",
  "SessionDeleted": "出於安全考慮，您的資料已被刪除。",
  "Accessibility": "無障礙",
  "TermsAndConditions": "條款與條件",
  "Regulation": "法規",
  "Privacy": "隱私",
  "DoNotSellMyPersonalInformation": "請勿出售我的個人資訊",
  "SiteMap": "網站地圖",
  "CopyrightText": "Pacific Gas and Electric Company",
  "DeleteFile": "刪除文件",
  "RemoveUploadedFileConfirmation": "您想刪除已上傳的檔案嗎？",
  "RemoveFile": "移除文件",
  "NoFileChosen": "未選擇文件",
  "arrowUP": "一支向上指的箭头，表示文件上传"
};